@for (item of items; track item.text) {
  <div
    class="item"
    [class.active]="isActive(item)"
    [innerText]="item.text"
    [routerLink]="item.onClick ? null : [item.href]"
    [routerLinkActive]="item.onClick ? null : 'active'"
    (click)="onItemClick(item, $event)"
  ></div>
}
